import { useMutation, useQueryClient } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import useMainWrapperStore, { TriggerLocation } from 'Features/MainWrapper/stores/mainWrapper'

import { useUserStore } from 'Stores/userStoreModuleFed'
import { DomainToServer } from 'Types/Domain'

type Params = {
  domains: Array<DomainToServer>
  triggerLocation?: TriggerLocation // update inside postAddDomain
}

type AddedDomain = {
  id: number
  address: string
  active: boolean
  tagHash: string
  tagId: number
  tagUrl: string
}

type AddDomainBody = {
  addedDomains: Array<AddedDomain>
}

const postAddDomain = (body: Params): Promise<{ data: AddDomainBody } | Error> => {
  const { accountId } = useUserStore.getState()
  const { triggerLocation } = useMainWrapperStore.getState()

  if (triggerLocation) body['triggerLocation'] = triggerLocation

  return request<{ data: AddDomainBody }>({
    method: 'POST',
    url: `accounts/${accountId}/domains`,
    data: body,
  })
}

export const useAddDomain = () => {
  const queryClient = useQueryClient()

  return useMutation(postAddDomain, {
    onSettled: () => {
      void queryClient.invalidateQueries(['domains'])
      void queryClient.invalidateQueries(['getUserDomains'])
    },
  })
}
